<script>
    import HeikinAshiCandle from './primitives/heikin_ashi_candle.js'
    import { Overlay, layout_cnv } from '../../'

    export default {
        name: 'HeikinAshi',
        mixins: [Overlay],
        methods: {
            meta_info() {
                return {
                    author: 'TradingCandle',
                    version: '1.1.0',
                    desc: 'Heikin Ashi Chart',
                    preset: {
                        name: 'HeikinAshi',
                        side: 'onchart',
                        settings: {
                            colorCandleUp: '#23a776',
                            colorCandleDw: '#e54150',
                            colorWickUp: '#666666',
                            lineWidth: 1
                        }
                    }
                }
            },
            init() {},
            draw(ctx) {
                let layout = this.$props.layout

                if (this.$props.sub === this.$props.data) {
                    var candles = layout.candles
                } else {
                    candles = layout_cnv(this).candles
                }

                if (!candles || candles.length === 0) return

                // Compute Heikin Ashi values and render
                let prevHaOpen = null
                let prevHaClose = null

                for (var i = 0, n = candles.length; i < n; i++) {
                    let c = candles[i]
                    let [ts, open, high, low, close, vol] = c.raw

                    // HA calculations
                    let haClose = (open + high + low + close) / 4
                    let haOpen = (i === 0) ? (open + close) / 2 : (prevHaOpen + prevHaClose) / 2
                    let haHigh = Math.max(high, haOpen, haClose)
                    let haLow = Math.min(low, haOpen, haClose)

                    let green = haClose >= haOpen

                    // Convert HA prices to screen coordinates using layout transform
                    let haData = {
                        x: c.x,
                        w: c.w,
                        o: Math.floor(haOpen * layout.A + layout.B),
                        h: Math.floor(haHigh * layout.A + layout.B),
                        l: Math.floor(haLow * layout.A + layout.B),
                        c: Math.floor(haClose * layout.A + layout.B),
                        raw: [ts, haOpen, haHigh, haLow, haClose, vol]
                    }

                    new HeikinAshiCandle(this, ctx, haData, green)

                    prevHaOpen = haOpen
                    prevHaClose = haClose
                }
            },
            use_for() { return ['HeikinAshi'] },
            y_range() {
                var hi = -Infinity, lo = Infinity
                for (var i = 0, n = this.sub.length; i < n; i++) {
                    let x = this.sub[i]
                    if (x[2] > hi) hi = x[2]
                    if (x[3] < lo) lo = x[3]
                }
                return [hi, lo]
            }
        },
        computed: {
            sett() { return this.$props.settings },
            upColor() { return this.sett.colorCandleUp || this.$props.colors.candleUp || '#23a776' },
            downColor() { return this.sett.colorCandleDw || this.$props.colors.candleDw || '#e54150' },
            wickColor() { return this.sett.colorWickUp || this.$props.colors.wickUp || '#666666' },
            lineWidth() { return this.sett.lineWidth || 1 }
        }
    }
</script>
